/**
 * Created by yougen.zhuangyg on 2014/10/30.
 */
var $ = require("@alife/alpha-jquery/jquery"),
    Xman = require('./xman.js'),
    CookieInfo = require('@alife/alpha-cookie-info/cookie-info');

var InquirySend = function(config){
    this.init(config);
};
InquirySend.prototype = {
    constructor: InquirySend,
    init: function(config){
        this.config = {
            loginId: '',
            callback: {fn: $.noop, context:this}
        };
        this.config = $.extend(this.config, config||{}) ;
    },
    _openOldXman: function(options){
        if(typeof options === 'string') {
            options = {
                bizScenes: options
            };
        }

        var activeIndex = 0, _self = this;

        Xman(function(gXman) {
            var xman = new gXman.Popup({
                    members: 'both',
                    bizScenes: options && options.bizScenes ? options.bizScenes : 'gangesweb',
                    noalibaba: options && options.noalibaba === true
                });
            xman.set('activeIndex',activeIndex);
            xman.set('xlogin.passport',_self.config.loginId);
            // xman在已登录状态下不检测当前登录账号, 需要强制弹窗
            // 第一次用户输入正确账号, 第二次输入错误账号,需要再次弹窗
            xman.set('forcePopup', true);
            xman.set('xjoin.fields', {
                country: {
                    name: '_fmh.min._0.xjoinco'
                },
                password: {
                    name: '_fmh.min._0.xjoin'
                },
                gender: {
                    name: '_fmh.min._0.xjoing'
                },
                checkToken: {
                    name: '_fmh.min._0.xjoinc'
                },
                businessRole: {
                    name: '_fmh.min._0.xjoinb',
                    defaultValue: 'both',
                    hidden: true
                },
                firstName: {
                    name: '_fmh.min._0.xj'
                },
                lastName: {
                    name: '_fmh.min._0.xjo'
                },
                companyName: {
                    name: '_fmh.min._0.x'
                },
                phoneArea: {
                    require: false,
                    hidden: true
                },
                phoneCountry: {
                    require: false,
                    hidden: true
                },
                phoneNumber: {
                    require: false,
                    hidden: true
                },
                email: {
                    name: '_fmh.min._0.xjoi',
                    "defaultValue": _self.config.loginId
                },
                xjoinGroupName: {
                    defaultValue: 'minAppendGenderRoleCompanyName'
                }
            });
            var invokeItem = _self.config.callback;

            xman.on('LOGIN_SUCCESS', function(){
                invokeItem.context.trigger('XMAN_LOGINED');
                invokeItem.fn.call(invokeItem.context);
            });
            xman.on('close', function(){
                invokeItem.context.trigger('XMAN_CLOSE');
            });
            if(invokeItem.context){
                invokeItem.context.trigger('SHOW_XMAN');
            }

            xman.show();
        });
    },
    openXman: function(options){
        this._openOldXman(options);
    },
    // checkEmail接口存在安全问题, 不再检查email
    checkEmail: function(options){
        if(typeof options === 'string') {
            options = {
                bizScenes: options
            };
        }
        this.openXman(options);
    }
};
InquirySend.initSecurityData = function(data){
    // 安全相关变量
    if(!data.commons){
        return;
    }
    window['image-check-code'] = window['image-check-code'] || {
        sId: data.commons.sId,
        imageUrl: data.commons.imageUrl,
        checkCodeName: data.commons.checkCodeName,
        collinaCheck: data.commons.collinaCheck
    };
    var tplData = {};
    $.extend(tplData, {
        checkCodeTips: "Please enter the characters in the image",
        checkCodeRefresh: "Load new image",
        checkCodeTitle: "Enter the code"
    }, window['image-check-code']);
    data.tplData = tplData;
};

module.exports = InquirySend;
